import { useEffect, useState } from "react";
import { isFavorite, toggleFavorite } from "@/lib/favorites";

interface FavoriteButtonProps {
  storageKey: string;
  id: string;
  label?: string;
}

export default function FavoriteButton({ storageKey, id, label = "收藏" }: FavoriteButtonProps) {
  const [fav, setFav] = useState(false);

  useEffect(() => {
    setFav(isFavorite(storageKey, id));
  }, [storageKey, id]);

  const handleToggle = () => {
    const { added } = toggleFavorite(storageKey, id);
    setFav(added);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`inline-flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
        fav
          ? "bg-primary-500 text-foreground-950"
          : "border border-background-300 bg-background-50 text-foreground-800 hover:border-primary-300"
      }`}
    >
      <i className={fav ? "ri-heart-3-fill w-4 h-4 flex items-center justify-center" : "ri-heart-3-line w-4 h-4 flex items-center justify-center"}></i>
      {fav ? "已收藏" : label}
    </button>
  );
}